import { render, staticRenderFns } from "./saveFreeOpenCourse.vue?vue&type=template&id=074e032c&"
import script from "./saveFreeOpenCourse.vue?vue&type=script&lang=js&"
export * from "./saveFreeOpenCourse.vue?vue&type=script&lang=js&"
import style0 from "./saveFreeOpenCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports